export default __webpack_public_path__ + "images/ebcf14708443acdf76b3f7a95b5cb8e2-Sample-Banner.jpg";